import { CiapSelectFieldModel } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { ProcedimentoSelectModel } from 'components/form/field/select/ProcedimentoSelectField'
import { SoapEditableItem } from 'view/atendimentos/atendimento-individual/model'

interface IntervencaoProcedimentoQueryModel {
  id: ID
  nota?: string
  ciap?: {
    id: ID
    codigo: string
    descricao: string
  }
  procedimento?: ProcedimentoSelectModel
  automatico?: boolean
}

export interface EvolucaoPlanoQueryModel {
  id: ID
  descricao?: string
  intervencoesProcedimentos?: ReadonlyArray<IntervencaoProcedimentoQueryModel>
}

export interface OrientacaoQueryModel {
  id: ID
  descricao: string
}

export interface CiapPlanoModel extends SoapEditableItem {
  _id: ID
  ciap: CiapSelectFieldModel
  observacao?: string
}

export const ALERTA_PROCEDIMENTO_INATIVO =
  'Para finalizar o atendimento, é necessário excluir o(s) procedimento(s) inativo(s).'
